require('./fundLegalConfirmation.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const classNames = require('classnames');
const { withRouter } = require('react-router-dom');

// @core
const { FormattedText, formatText } = require('core/i18n').i18n;
const apiURLBuilder = require('core/apiURLBuilder')
// @components
const BrokerLegalConfirmation = require('components/contactCenter/brokerLegalConfirmation/brokerLegalConfirmation');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKLink } = require('commonsComponents/OKLink');
// @actions
const brokerFundLegalDocumentActions = require('actions/brokerFundLegalDocument');
const fundLegalConfirmationActions = require('actions/contactCenter/fundLegalConfirmationActions');
// @utilities
const PersonalDataHelper = require('utilities/personalDataHelper');
const { buildLinkButton, buildLinkOrLabel } = require('utilities/contactCenter/UIElementsHelper');
const { downloadAsFile, base64ToBlob } = require('utilities/APIRequestHelper');

// @constants
const { CONTENT_TYPE_PDF, LEGAL_DOCUMENTS_TYPES } = require('constants/index');
const { COUNTRIES_CODES: { DE, PT } } = require('constants/countries');
const { openBase64pdfInNewTab } = require('../../../../utilities/pdfDocumentsHelper');

class FundLegalConfirmation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasResolvedDependencies: false,
      infoFetched: false,
    };

    this.handleYesNoOptionChange = this.handleYesNoOptionChange.bind(this);
    this.handleInformationOfCostsAndAssociatedExpensesLinkClick =
      this.handleInformationOfCostsAndAssociatedExpensesLinkClick.bind(this);
    this.updateState = this.updateState.bind(this);
  }

  componentDidMount() {
    const {
      immFundLegalConfirmation,
      fetchFundMorningstarSecurityDetails,
      fundId,
      fundIsin,
      isAlternativeFund,
      fetchAlternativeFundsLegalDocuments,
      immProfile,
      history,
    } = this.props;
    const isFetchedMorningstarSecurityDetails = immFundLegalConfirmation.get('isFetched');
    const originCountry = immProfile.get('originCountry');
    if (isAlternativeFund) {
      fetchAlternativeFundsLegalDocuments(fundIsin, originCountry, () => {}, history);
    } else if (!isFetchedMorningstarSecurityDetails && fundId) {
      fetchFundMorningstarSecurityDetails(fundId);
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      onResolvedDependencies,
      immBrokerFundLegalDocument: oldImmBrokerFundLegalDocument,
      immFundLegalConfirmation: oldImmFundLegalConfirmation,
    } = this.props;

    const { immBrokerFundLegalDocument, immFundLegalConfirmation } = nextProps;

    if (
      immBrokerFundLegalDocument !== oldImmBrokerFundLegalDocument ||
      oldImmFundLegalConfirmation !== immFundLegalConfirmation
    ) {
      const isFetchingLegalDocuments = immBrokerFundLegalDocument.get('isFetching');
      const isFetchingMorningstarSecurityDetails = immFundLegalConfirmation.get('isFetching');
      const isFetchedMorningstarSecurityDetails = immFundLegalConfirmation.get('isFetched');
      const resolved =
        !isFetchingLegalDocuments &&
        !isFetchingMorningstarSecurityDetails &&
        isFetchedMorningstarSecurityDetails;

      this.setState(state => {
        if (onResolvedDependencies && state.hasResolvedDependencies !== resolved) {
          onResolvedDependencies(resolved);
        }

        return {
          hasResolvedDependencies: resolved,
        };
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { infoFetched } = this.state;
    const {
      fundIsin,
      fundSecId,
      costDocumentType,
      costOrderType,
      fetchLegalDocuments,
      fetchFundMorningstarSecurityDetails,
      immFundLegalConfirmation,
      withoutCostDocument,
      exAntCost,
      history,
    } = this.props;
    const fundIsinValue = fundIsin || prevProps.fundIsin;
    const isFetchedMorningstarSecurityDetails = immFundLegalConfirmation.get('isFetched');
    const fundSecIdValue = fundSecId || prevProps.fundSecId;
    if (fundIsinValue && fundSecIdValue && !infoFetched) {
      const doNotSendCostDocument = withoutCostDocument || !!exAntCost;
      fetchLegalDocuments(
        fundIsin,
        fundSecId,
        costDocumentType,
        costOrderType,
        doNotSendCostDocument,
        history
      );
      if (!isFetchedMorningstarSecurityDetails) {
        fetchFundMorningstarSecurityDetails(fundSecId);
      }
      this.updateState({ infoFetched: true });
    }
  }

  componentWillUnmount() {
    this.props.resetFundMorningstarSecurityDetails();
  }

  updateState(newState) {
    this.setState(newState);
  }

  handleYesNoOptionChange(value) {
    this.props.onYesNoOptionChange(value);
  }

  handleInformationOfCostsAndAssociatedExpensesLinkClick() {
    const { immBrokerFundLegalDocument, fundIsin } = this.props;

    const immFundTransactionCostDocument = immBrokerFundLegalDocument.getIn([
      'fundTransactionCostDocument',
      fundIsin,
    ]);
    const dataBlock = immFundTransactionCostDocument
      ? immFundTransactionCostDocument.get('base64Data')
      : '';
    const dataID = immFundTransactionCostDocument
      ? immFundTransactionCostDocument.get('objectId')
      : '';

    if (dataBlock && dataID) {
      const base64String = `data:${CONTENT_TYPE_PDF};base64,${dataBlock}`;
      downloadAsFile(base64ToBlob(base64String), CONTENT_TYPE_PDF, dataID);
    }
  }

  isSpanishFund() {
    const { fundIsin } = this.props;

    return (fundIsin + '').slice(0, 2).toLowerCase() === 'es';
  }

  buildDocumentLink(labelTranslationKey, documentUrlKey, handleClick) {
    let link;
    const { immBrokerFundLegalDocument, immProfile } = this.props;
    const originCountry = immProfile.get('originCountry');
    const label = formatText(`fundLegalConfirmation-${labelTranslationKey}`);

    if (originCountry === PT && !immBrokerFundLegalDocument.get(documentUrlKey)) {
      link = documentUrlKey;
    } else {
      link = immBrokerFundLegalDocument.get(documentUrlKey);
    }

    if (handleClick) {
      return buildLinkButton(label, handleClick, 'fund-legal-confirmation__document-link');
    }

    return buildLinkOrLabel(label, link, 'fund-legal-confirmation__document-link');
  }

  buildLegalDisclaimerQuestion() {
    const { immProfileFields } = this.props;

    const clientName = PersonalDataHelper.getFullName(immProfileFields, false);

    return (
      <div>
        <p>
          <FormattedText value="fundLegalConfirmation-legalDisclaimerQuestionFirstStatement" />
        </p>
        <p>
          <FormattedText
            value="fundLegalConfirmation-legalDisclaimerQuestionSecondStatement"
            injectedStrings={[clientName]}
          />
        </p>
      </div>
    );
  }

  buildLegalTextDocumentLinks() {
    const {
      immProfile,
      immFlagBasedFeatures,
      sendMarketingReport,
      withoutCostDocument,
      exAntCost,
      fundIsin,
      isAlternativeFund,
    } = this.props;
    const isSpanish = this.isSpanishFund();
    const originCountry = immProfile.get('originCountry');
    const disabledCostDocumment = withoutCostDocument || !!exAntCost;
    const secondStatementKey = disabledCostDocumment
      ? 'fundLegalConfirmation-legalDisclaimerDocumentLinksSecondStatementWithoutCostDocument'
      : 'fundLegalConfirmation-legalDisclaimerDocumentLinksSecondStatement';
    const secondStatementForeignKey = disabledCostDocumment
      ? originCountry === PT
        ? 'fundLegalConfirmation-ptLegalDisclaimerDocumentLinksSecondStatementForeignWithoutCost'
        : 'fundLegalConfirmation-legalDisclaimerDocumentLinksSecondStatementForeignWithoutCost'
      : 'fundLegalConfirmation-legalDisclaimerDocumentLinksSecondStatementForeign';
    const legalDisclaimerDocumentLinksSecondStatement =
      !sendMarketingReport || isSpanish || immProfile.get('originCountry').toUpperCase() === DE
        ? secondStatementKey
        : secondStatementForeignKey;

    const marketingReportsLink =
      !sendMarketingReport || isSpanish || immProfile.get('originCountry').toUpperCase() === DE
        ? ''
        : this.buildDocumentLink('marketingReportsLabelLink', 'marketingReportsUrl');
    const fundamentalDataForInvestorLink = this.buildDocumentLink(
      'fundamentalDataForInvesorLabelLink',
      'fundamentalDataForInvesorUrl'
    );
    const lastPublishedEconomicReportLink = this.buildDocumentLink(
      'lastPublishedEconomicReportLabelLink',
      'lastPublishedEconomicReportUrl'
    );
    const costsAndAssociatedExpensesReportLink = disabledCostDocumment
      ? null
      : this.buildDocumentLink(
          'costsAndAssociatedExpensesReportLabelLink',
          '',
          this.handleInformationOfCostsAndAssociatedExpensesLinkClick
        );

    const legalinformationLinks =
      !sendMarketingReport || isSpanish || immProfile.get('originCountry').toUpperCase() === DE
        ? [
            fundamentalDataForInvestorLink,
            lastPublishedEconomicReportLink,
            costsAndAssociatedExpensesReportLink,
          ]
        : [
            fundamentalDataForInvestorLink,
            lastPublishedEconomicReportLink,
            marketingReportsLink,
            costsAndAssociatedExpensesReportLink,
          ];

    if (originCountry === PT) {
      const prospectusReportLink = apiURLBuilder.getURL('morningstarFundDocumentPDF', {
        isin: fundIsin,
        documentType: 'Prospectus',
        originCountry: originCountry,
      });
      const prospectusFile = this.buildDocumentLink('prospectusLabelLink', prospectusReportLink);

      const anualReportLink = apiURLBuilder.getURL('morningstarFundDocumentPDF', {
        isin: fundIsin,
        documentType: 'Anual',
        originCountry: originCountry,
      });
      const anualFile = this.buildDocumentLink('anualLabelLink', anualReportLink);

      const nullDocument = legalinformationLinks.findIndex(e => e === null);
      legalinformationLinks.splice(nullDocument);
      legalinformationLinks.push(prospectusFile);
      legalinformationLinks.push(anualFile);
    }

    const buildLinkComponent = (labelTranslationKey, documentUrl, kindOfURL) => {
      const openBase64InNewTab = kindOfURL === 'base64';
      if (openBase64InNewTab) {
        return (
          <OKLink
          modifier="emphasize"
          name={'legalDocuments'}
          className="fund-legal-confirmation__document-link"
          onClick={() => openBase64pdfInNewTab(documentUrl)}
        >
          <FormattedText value={`brokerAlternativeFundsCC-${labelTranslationKey}`} />
        </OKLink>
        );
      }

      return (
        <OKLink
          modifier="emphasize"
          name={'legalDocuments'}
          to={documentUrl}
          extraClass="fund-legal-confirmation__document-link"
        >
          <FormattedText value={`brokerAlternativeFundsCC-${labelTranslationKey}`} />
        </OKLink>
      );
    };

    const getAlternativeFundsDocuments = () => {
      const { immBrokerFundLegalDocument } = this.props;
      const { PROSPECTUS, INFORME_SEMESTRAL, DFI, RISKS, RECOMMENDATIONS } = LEGAL_DOCUMENTS_TYPES;
      const alternativeFundsDocs = immBrokerFundLegalDocument.get('alternativeFundsDocs');

      const showPurchaseAnnualReport = immFlagBasedFeatures.get(
        'wealth_funds_show_transfer_annual_report_document'
      );
      const showPurchaseProspectusReport = immFlagBasedFeatures.get(
        'wealth_funds_show_purchase_prospectus_document'
      );
    
      const showRiskAssumptionDocument = immFlagBasedFeatures.get(
        'wealth_funds_show_risk_assumption_document'
      );
      const showRecomendationReport = immFlagBasedFeatures.get(
        'wealth_funds_show_recommendation_report_document'
      );

      const documents = {
        recommendationReport: {
          label: 'investment_doc',
          url: alternativeFundsDocs.getIn([RECOMMENDATIONS, 'urlToOpen']),
          kindOfURL: 'base64',
          showLink: showRecomendationReport,
        },
        riskAssumptionDocument: {
          label: 'consent_doc',
          url: alternativeFundsDocs.getIn([RISKS, 'urlToOpen']),
          kindOfURL: 'base64',
          showLink: showRiskAssumptionDocument,
        },
        dfi: {
          label: 'DFI',
          url: alternativeFundsDocs.getIn([DFI, 'urlToOpen']),
          kindOfURL: 'url',
          showLink: true,
        },
        prospectus: {
          label: 'prospectus',
          url: alternativeFundsDocs.getIn([PROSPECTUS, 'urlToOpen']),
          kindOfURL: 'url',
          showLink: true,
        },
        commercialReport: {
          label: 'last_report',
          url: alternativeFundsDocs.getIn([INFORME_SEMESTRAL, 'urlToOpen']),
          kindOfURL: 'url',
          showLink: showPurchaseAnnualReport,
        },
      };

      const alternativeFundsDocumentsLinks = Object.keys(documents).map(key => {
        const { label, url, kindOfURL, showLink } = documents[key];
        return url && showLink ? buildLinkComponent(label, url, kindOfURL) : null;
      });

      return alternativeFundsDocumentsLinks;
    };

    const alternativeFundsDocumentsLinks = getAlternativeFundsDocuments();
    const legalDisclaimerDocumentLinksSecondStatementKey = isAlternativeFund
      ? 'brokerAlternativeFundsCC-legalDisclaimerDocumentLinksSecondStatementKey'
      : legalDisclaimerDocumentLinksSecondStatement;
    return (
      <div>
        <p>
          <FormattedText value="fundLegalConfirmation-legalDisclaimerDocumentLinksFirstStatement" />
        </p>
        <p>
          <FormattedTextWithComponents
            value={legalDisclaimerDocumentLinksSecondStatementKey}
            injectedComponents={
              isAlternativeFund ? alternativeFundsDocumentsLinks : legalinformationLinks
            }
          />
        </p>
      </div>
    );
  }

  buildLegalDisclaimerYesAnswer() {
    return (
      <div>
        <p>
          <FormattedText value="fundLegalConfirmation-legalDisclaimerYesAnswerStatement" />
        </p>
      </div>
    );
  }

  buildLegalDisclaimerNoAnswer() {
    return (
      <div>
        <p>
          <FormattedText value="fundLegalConfirmation-legalDisclaimerNoAnswerFirstStatement" />
        </p>
        <p>
          <FormattedText value="fundLegalConfirmation-legalDisclaimerNoAnswerSecondStatement" />
        </p>
      </div>
    );
  }

  buildLegalTextProductDescription() {
    const { immProfileFields, fundName, immFundLegalConfirmation } = this.props;

    const clientName = PersonalDataHelper.getFullName(immProfileFields, false);

    const notAvailable = formatText('fundLegalConfirmation-notAvailable');
    const investmentStrategy = immFundLegalConfirmation.get('fetchError')
      ? notAvailable
      : immFundLegalConfirmation.get('investmentStrategy');
    const riskLevel = immFundLegalConfirmation.get('fetchError')
      ? notAvailable
      : immFundLegalConfirmation.get('KIDSRI');

    const investmentStrategyComponent = (
      <p className="fund-legal-confirmation__investment-strategy">{investmentStrategy}</p>
    );

    const riskLevelComponent = (
      <span className="fund-legal-confirmation__risk-level">{riskLevel}</span>
    );

    return (
      <div>
        <p>
          <FormattedText
            value="fundLegalConfirmation-investmentFundsTitleMainFeatures"
            injectedStrings={[clientName]}
          />
        </p>
        <ul>
          <li className="fund-legal-confirmation__fund-feature">
            <FormattedText
              value="fundLegalConfirmation-firstInvestmentFundFeature"
              injectedStrings={[fundName]}
            />
          </li>
          <li className="fund-legal-confirmation__fund-feature">
            <FormattedTextWithComponents
              value="fundLegalConfirmation-secondInvestmentFundFeature"
              injectedComponents={[investmentStrategyComponent]}
            />
          </li>
          <li className="fund-legal-confirmation__fund-feature">
            <FormattedTextWithComponents
              value="fundLegalConfirmation-thirdInvestmentFundFeature"
              injectedComponents={[riskLevelComponent]}
            />
          </li>
        </ul>
      </div>
    );
  }

  buildImportantInformation() {
    const { isAlternativeFund } = this.props;

    if (isAlternativeFund) {
      return (
        <div>
          <p>
            <FormattedText
              className="fund-legal-confirmation__important-info-title"
              value="fundLegalConfirmation-importantInfoTitle"
            />
          </p>
          <ul>
            <li className="fund-legal-confirmation__important-info-title">
              <FormattedText value="fundLegalConfirmation-importantInfoItemTitle1" />
            </li>
            <div className="fund-legal-confirmation__important-info-item-text">
              <FormattedText value="fundLegalConfirmation-importantInfoItemText1" />
            </div>
            <li className="fund-legal-confirmation__important-info-title">
              <FormattedText value="fundLegalConfirmation-importantInfoItemTitle2" />
            </li>
            <div className="fund-legal-confirmation__important-info-item-text">
              <FormattedText value="fundLegalConfirmation-importantInfoItemText2" />
            </div>
            <div className="fund-legal-confirmation__important-info-item-text">
              <FormattedText value="fundLegalConfirmation-importantInfoItemText3" />
            </div>
          </ul>
        </div>
      );
    } else null;
  }

  buildLegalTextMandatoryReading() {
    const { withoutCostDocument } = this.props;
    if (withoutCostDocument) {
      return null;
    } else {
      const costsAndAssociatedExpensesReportLink = this.buildDocumentLink(
        'costsAndAssociatedExpensesReportLabelLink1',
        '',
        this.handleInformationOfCostsAndAssociatedExpensesLinkClick
      );
      return (
        <div>
          <p>
            <FormattedTextWithComponents
              value="fundLegalConfirmation-legalTextMandatoryReading1"
              injectedComponents={[costsAndAssociatedExpensesReportLink]}
            />
          </p>
          <ul>
            <li className="fund-legal-confirmation__mandatory-reading-line">
              <FormattedText value="fundLegalConfirmation-legalTextMandatoryReading2" />
            </li>
            <li className="fund-legal-confirmation__mandatory-reading-line">
              <FormattedText value="fundLegalConfirmation-legalTextMandatoryReading3" />
            </li>
            <li className="fund-legal-confirmation__mandatory-reading-line">
              <FormattedText value="fundLegalConfirmation-legalTextMandatoryReading4" />
            </li>
          </ul>
        </div>
      );
    }
  }

  completeEmailParams() {
    const {
      immBrokerFundLegalDocument,
      sendMarketingReport,
      sendMailParams,
      fundIsin,
      immProfile,
      immInvestmentFunds,
    } = this.props;
    const { INFORME_SEMESTRAL, DFI, RISKS, RECOMMENDATIONS, PROSPECTUS } = LEGAL_DOCUMENTS_TYPES;
    const originCountry = immProfile.get('originCountry');
    const immFundTransactionCostDocument = immBrokerFundLegalDocument.getIn([
      'fundTransactionCostDocument',
      fundIsin,
    ]);
    const costYieldObjectId = immFundTransactionCostDocument
      ? immFundTransactionCostDocument.get('objectId')
      : '';
    const fundamentalDataForInvestorURL = immBrokerFundLegalDocument.get(
      'fundamentalDataForInvesorUrl'
    );
    const lastPublishedEconomicReportURL = immBrokerFundLegalDocument.get(
      'lastPublishedEconomicReportUrl'
    );
    let marketingReportsURL =
      !sendMarketingReport ||
      this.isSpanishFund() ||
      immProfile.get('originCountry').toUpperCase() === DE
        ? ''
        : immBrokerFundLegalDocument.get('marketingReportsUrl');


    const alternativeFundsDocs = immBrokerFundLegalDocument.get('alternativeFundsDocs');
    const isAlternativeFund = immInvestmentFunds.get('isAlternativeFund')

    const recommendationReport = alternativeFundsDocs.getIn([RECOMMENDATIONS, 'originURL' ]);
    const riskAssumptionDocument = alternativeFundsDocs.getIn([RISKS, 'originURL' ]);
    const prospectusReport = alternativeFundsDocs.getIn([PROSPECTUS, 'originURL' ]);
    const commercialReport = alternativeFundsDocs.getIn([INFORME_SEMESTRAL, 'originURL' ]);
    const dfi = alternativeFundsDocs.getIn([DFI, 'originURL' ]);
    const traditionalFundDocuments = {
      marketingReport: marketingReportsURL,
      productKID: fundamentalDataForInvestorURL,
      economicReport: lastPublishedEconomicReportURL,
      costYield: costYieldObjectId,
    };

    const alternativeFundsDocuments = {
      recommendationReport: recommendationReport,
      riskAssumptionDocument: riskAssumptionDocument,
      prospectus: prospectusReport,
      commercialReport: commercialReport,
      productKID: dfi,
      isPrivateEquity: true
    }

    const paramsToSend = isAlternativeFund ? alternativeFundsDocuments : traditionalFundDocuments;

    let params = Object.assign(
      {},
      paramsToSend,
      sendMailParams
    );

    if (originCountry === PT) {
      const prospectusReportLink = apiURLBuilder.getURL('morningstarFundDocumentPDF', {
        isin: fundIsin,
        documentType: 'Prospectus',
        originCountry: originCountry,
      });
      const anualReportLink = apiURLBuilder.getURL('morningstarFundDocumentPDF', {
        isin: fundIsin,
        documentType: 'Anual',
        originCountry: originCountry,
      });
      params = Object.assign(
        {},
        {
          marketingReport: marketingReportsURL,
          productKID: fundamentalDataForInvestorURL,
          economicReport: lastPublishedEconomicReportURL,
          costYield: costYieldObjectId,
          prospectus: prospectusReportLink,
          annualEconomicReport: anualReportLink,
        },
        sendMailParams
      );
    }

    return params;
  }

  buildBrokerLegalConfirmation() {
    const {
      immProfileFields,
      immPreContractualMail,
      sendMail,
      resetMailState,
      requestProfile,
      selectedYesNoOption,
      immBrokerFundLegalDocument,
      immFundLegalConfirmation,
      exAntCost,
    } = this.props;

    const { hasResolvedDependencies } = this.state;

    const isFetchingLegalDocuments = immBrokerFundLegalDocument.get('isFetching');
    const isFetchingMorningstarSecurityDetails = immFundLegalConfirmation.get('isFetching');
    const isFetchedMorningstarSecurityDetails = immFundLegalConfirmation.get('isFetched');
    const resolved =
      !isFetchingLegalDocuments &&
      !isFetchingMorningstarSecurityDetails &&
      isFetchedMorningstarSecurityDetails;

    if (!hasResolvedDependencies && !resolved) {
      return <LoadingSection />;
    }

    const clientEmail = PersonalDataHelper.getEmail(immProfileFields);
    const refreshEmailError = immProfileFields.get('error')
      ? immProfileFields.getIn(['error', 'description'], 'Error')
      : undefined;
    const emailParams = this.completeEmailParams();

    return (
      <BrokerLegalConfirmation
        className="fund-legal-confirmation__legal-confirmation"
        legalDisclaimerProductDescription={this.buildLegalTextProductDescription()}
        legalDisclaimerMandatoryReading={this.buildLegalTextMandatoryReading()}
        importantInformation={this.buildImportantInformation()}
        legalDisclaimerDocumentLinks={this.buildLegalTextDocumentLinks()}
        clientEmailAddress={clientEmail}
        refreshEmailAddress={requestProfile}
        refreshEmailAddressError={refreshEmailError}
        sendMail={sendMail}
        sendMailParams={emailParams}
        immPreContractualMail={immPreContractualMail}
        resetMailState={resetMailState}
        legalDisclaimerQuestion={this.buildLegalDisclaimerQuestion()}
        selectedYesNoOption={selectedYesNoOption}
        onYesNoOptionChange={this.handleYesNoOptionChange}
        legalDisclaimerYesAnswer={this.buildLegalDisclaimerYesAnswer()}
        legalDisclaimerNoAnswer={this.buildLegalDisclaimerNoAnswer()}
        exAntCost={exAntCost}
      />
    );
  }

  render() {
    const { className } = this.props;
    const fundLegalConfirmationClassNames = classNames('fund-legal-confirmation', {
      [className]: !!className,
    });

    return (
      <div className={fundLegalConfirmationClassNames}>{this.buildBrokerLegalConfirmation()}</div>
    );
  }
}

FundLegalConfirmation.propTypes = {
    className: PropTypes.string,
    fundIsin: PropTypes.string.isRequired,
    fundSecId: PropTypes.string.isRequired,
    fundId: PropTypes.string,
    fundName: PropTypes.string.isRequired,
    costDocumentType: PropTypes.string.isRequired,
    costOrderType: PropTypes.string.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    sendMail: PropTypes.func.isRequired,
    sendMailParams: PropTypes.object.isRequired,
    resetMailState: PropTypes.func.isRequired,
    selectedYesNoOption: PropTypes.string.isRequired,
    requestProfile: PropTypes.func.isRequired,
    onYesNoOptionChange: PropTypes.func.isRequired,
    immBrokerFundLegalDocument: PropTypes.object.isRequired,
    immFundLegalConfirmation: PropTypes.object.isRequired,
    fetchLegalDocuments: PropTypes.func.isRequired,
    fetchFundMorningstarSecurityDetails: PropTypes.func.isRequired,
    resetFundMorningstarSecurityDetails: PropTypes.func.isRequired,
    onResolvedDependencies: PropTypes.func,
    immProfile: PropTypes.object.isRequired,
    sendMarketingReport: PropTypes.bool,
    withoutCostDocument: PropTypes.bool,
    exAntCost: PropTypes.node,
    history: PropTypes.object.isRequired,
    fetchAlternativeFundsLegalDocuments: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
};

FundLegalConfirmation.defaultProps = {
    sendMarketingReport: true,
    withoutCostDocument: false,
    exAntCost: null,
};

module.exports.constructor = FundLegalConfirmation;
module.exports.FundLegalConfirmation = withRouter(connect(state => ({
    immBrokerFundLegalDocument: state.brokerFundLegalDocument,
    immFundLegalConfirmation: state.fundLegalConfirmation,
    immProfile: state.profile,
    immInvestmentFunds: state.investmentFunds,
    immFlagBasedFeatures: state.flagBasedFeatures,
}), {
    fetchLegalDocuments: brokerFundLegalDocumentActions.parametrizableFetchLegalDocuments,
    fetchFundMorningstarSecurityDetails: fundLegalConfirmationActions.fetchFundMorningstarSecurityDetails,
    resetFundMorningstarSecurityDetails: fundLegalConfirmationActions.reset,
    fetchAlternativeFundsLegalDocuments: brokerFundLegalDocumentActions.fetchAlternativeFundsLegalDocuments,
  })(FundLegalConfirmation));
